// MySQL Schema Compiler
// -------
var inherits = require('inherits');

var SchemaCompiler = require('../../../schema/compiler');

var _require = require('lodash'),
    some = _require.some;

function SchemaCompiler_MySQL(client, builder) {
  SchemaCompiler.call(this, client, builder);
}

inherits(SchemaCompiler_MySQL, SchemaCompiler);
Object.assign(SchemaCompiler_MySQL.prototype, {
  // Rename a table on the schema.
  renameTable: function renameTable(tableName, to) {
    this.pushQuery("rename table ".concat(this.formatter.wrap(tableName), " to ").concat(this.formatter.wrap(to)));
  },
  // Check whether a table exists on the query.
  hasTable: function hasTable(tableName) {
    var sql = 'select * from information_schema.tables where table_name = ?';
    var bindings = [tableName];

    if (this.schema) {
      sql += ' and table_schema = ?';
      bindings.push(this.schema);
    } else {
      sql += ' and table_schema = database()';
    }

    this.pushQuery({
      sql: sql,
      bindings: bindings,
      output: function output(resp) {
        return resp.length > 0;
      }
    });
  },
  // Check whether a column exists on the schema.
  hasColumn: function hasColumn(tableName, column) {
    this.pushQuery({
      sql: "show columns from ".concat(this.formatter.wrap(tableName)),
      output: function output(resp) {
        var _this = this;

        return some(resp, function (row) {
          return _this.client.wrapIdentifier(row.Field) === _this.client.wrapIdentifier(column);
        });
      }
    });
  }
});
module.exports = SchemaCompiler_MySQL;